var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocChanges(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Outline / Document Changes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9484 15.7476C14.6158 16.0925 14.0767 16.0925 13.7435 15.7476L10.5983 12.4861C10.5717 12.4585 10.5468 12.4292 10.5242 12.3981C10.2385 12.011 10.3098 11.4568 10.6831 11.16L17.4543 6.18191C17.7932 5.91271 18.2723 5.94556 18.5738 6.25875L19.7504 7.47806C20.0525 7.79124 20.0842 8.28742 19.8245 8.63932L15.0225 15.6597C14.9999 15.6907 14.975 15.72 14.9484 15.7476ZM13.0082 16.2285L11.8112 16.849C11.6472 16.9341 11.4492 16.9007 11.3191 16.7663L9.61577 15.0004C9.48566 14.8655 9.45398 14.6602 9.53601 14.4901L10.1345 13.2491L13.0082 16.2285ZM9.13774 15.7541L10.5921 17.2619L10.0049 17.8707C9.89066 17.9886 9.72209 18.0302 9.56879 17.9775L8.29149 17.5358C7.99112 17.432 7.90117 17.0367 8.12462 16.8045L9.13774 15.7541Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocChanges);
export default __webpack_public_path__ + "static/media/doc-changes.2fbe75e6d5cf6ad8a8cf5fa2851ccb0c.svg";
export { ForwardRef as ReactComponent };